import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NotificationsState {
	notifications: NotificationBlock[];
}

export type NotificationBlock = {
	id: string;
	message: string;
	severity: 'info' | 'success' | 'warning' | 'error';
	dismissable?: boolean;
	navigation?: string;
	actionText?: string;
	rq?: string;
};

const initialState: NotificationsState = {
	notifications: []
};

const slice = createSlice({
	name: 'notification',
	initialState,
	reducers: {
		addNotification(state, action: PayloadAction<NotificationBlock>) {
			state.notifications = [...state.notifications, action.payload];
		},
		removeNotification(state, action: PayloadAction<string>) {
			state.notifications = state.notifications.filter((n) => n.id !== action.payload);
		}
	}
});

export default slice.reducer;
export const { addNotification, removeNotification } = slice.actions;
